import React from "react";

function ProfileBio({ text }) {
  return <p className="profile-card__bio">{text}</p>;
}

export default ProfileBio;
